import * as _ from 'lodash-es';

const populateObjects = <T>(
  map: Record<string, T>,
  target?: ({ id: string } | string | undefined | null)[] | null,
): T[] =>
  _.compact(
    _.compact(target || []).map((obj) =>
      typeof obj === 'string' ? map[obj] : map[obj.id],
    ),
  ) || [];

export default populateObjects;
